export * from './tagged-object.type';
